export const OPEN_SIDEBAR = 'OPEN_SIDEBAR'

export const OPEN_SIDEBAR_action = () => {
    return {
        type: OPEN_SIDEBAR
    }
}

export const CLOSE_SIDEBAR = 'CLOSE_SIDEBAR'

export const CLOSE_SIDEBAR_action = () => {
    return {
        type: CLOSE_SIDEBAR
    }
}